import React from 'react';
import TripsDisplay from './TripsDisplay';

function TripsNearbyDisplay({ trips, allViewTripsLength, searchQuery, loadMore, hasMore, loading }) {

  return (
    
    <div className='userSelectNone' style={{ marginTop: '3.5rem' }}>

      <div style={{ marginTop: '2rem', marginBottom: '1rem', textAlign: 'center' }}>
        <hr style={{borderTop: '2px solid #2a9d8f', marginBottom: '0.3rem' }} />
        <h4 style={{fontSize: '1.1rem', padding: '1.5vh', fontWeight: 'bold' }}>Przejazdy w pobliżu {searchQuery}:</h4>
      </div>
      
      <TripsDisplay
        trips={trips}
        allViewTripsLength={allViewTripsLength}
        loadMore={loadMore}
        hasMore={hasMore}
        loading={loading}
      />

    </div>
  );
}

export default TripsNearbyDisplay;